/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import "react-clock/dist/Clock.css";
import { connect, useDispatch } from "react-redux";
import "react-time-picker/dist/TimePicker.css";
import { useQuery } from "react-query";
import {
  getConsultationsByPatient
} from "../../redux/consultations/actions";
import { setCurrentPatient } from "../../redux/users/actions";
import { getUserById } from "../../services/users";
import {
  getStoragePatient,
  getUserData,
  setStoragePatient,
} from "../../utils/storageUtils";
import DashboardWrapper from "../Layout/DashboardWrapper";
import TabsCustom from "./Tabs";

const storagePatient = getStoragePatient();
const storageUser = getUserData()

const Consultation = ({
  current_patient: curr_patient,
  errors,
}) => {
  const dispatch = useDispatch();

  const current_patient = Object.keys(curr_patient).length
    ? curr_patient
    : storagePatient;

  const [form, setForm] = useState({
    actsDiagnosticRequests: [
      {
        id: 0,
        actsId: null,
        eyeTypeName: "",
        result: "",
        resultFile: "",
      },
    ],
    dosageRequests: [
      {
        id: 0,
        drugsId: 0,
        frequency: "",
        quantity: 0,
      },
    ],
    doctorId: current_patient?.doctor?.id,
    patientId: current_patient?.id,
    appointmentTime: "10:00",
  });

  useEffect(() => {
  }, [form]);

  useEffect(() => {
    setForm({
      ...form,
      patientId: current_patient?.id,
      doctorId: current_patient?.doctor?.id,
    });
  }, []);

  useEffect(() => {
    // Acts/Drugs/Diseases ne sont plus chargés en eager au mount : les
    // selects qui les consommaient utilisent maintenant les hooks lookup
    // (`useActsLookup`, `useDrugsLookupSearch`, `useDiseasesLookupSearch`).
    // Cf. CLAUDE.md → migration des selects vers `/lookup` (2026-05-07).
    if (current_patient?.id != null) {
      dispatch(getConsultationsByPatient(current_patient.id));
    }
  }, [current_patient]);

  // Hydrate `current_patient` avec le DTO complet via GET /users/{id}.
  // Le `current_patient` arrivé du listing paginé `/users/patients` ne
  // contient qu'un summary (pas de `medicalFamilyHistories`, pas de
  // `consultations`, etc.). Sans ce refetch, TabOne affiche les
  // antécédents vides et TabThree/TabFour ne voient pas certaines
  // métadonnées de couverture insurer (régression observée 2026-05-05).
  // On dispatche `setCurrentPatient` côté Redux + storage pour que
  // tous les Tabs (montés en parallèle) bénéficient de la donnée fraîche.
  const { data: fullPatientResult } = useQuery(
    ["consultation-full-patient", current_patient?.id],
    () => getUserById(current_patient.id),
    {
      enabled: current_patient?.id != null,
      staleTime: 30000,
    }
  );
  useEffect(() => {
    const fullPatient = fullPatientResult?.data;
    if (fullPatient && fullPatient.id === current_patient?.id) {
      dispatch(setCurrentPatient(fullPatient));
      setStoragePatient(fullPatient);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fullPatientResult]);

  // Carte d'en-tête : eyebrow + nom + meta. Pas de bouton retour (le
  // routeur conserve l'historique navigateur). Le sub-titre montre
  // l'âge / sexe / médecin traitant pour situer la consultation au
  // premier coup d'œil.
  const ageSex = [
    current_patient?.age ? `${current_patient.age} ans` : null,
    current_patient?.sex === "M"
      ? "Masculin"
      : current_patient?.sex === "F"
      ? "Féminin"
      : null,
  ]
    .filter(Boolean)
    .join(" · ");
  const doctorLabel =
    (current_patient?.doctor?.firstName || "") +
    " " +
    (current_patient?.doctor?.lastName || "");

  return (
    <DashboardWrapper>
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-2 duration-500 fill-mode-both">
        {/* Hero patient — carte arrondie avec eyebrow + identité */}
        <header className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 shadow-sm">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
            <div className="min-w-0">
              <p className="text-[11px] uppercase tracking-[0.32em] text-emerald-700 font-semibold">
                Consultation en cours
              </p>
              <h1 className="mt-1 text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 truncate">
                {current_patient?.firstName} {current_patient?.lastName}
              </h1>
              <p className="mt-1 text-sm text-slate-500">
                {ageSex || "Patient"}
                {doctorLabel.trim() && (
                  <>
                    <span className="mx-2 text-slate-300">·</span>
                    <span>
                      <i className="bx bx-plus-medical text-emerald-500 align-middle pr-1" />
                      Dr {doctorLabel.trim()}
                    </span>
                  </>
                )}
              </p>
            </div>
            {current_patient?.insurer?.name && (
              <span className="self-start sm:self-end inline-flex items-center gap-1.5 rounded-full border border-emerald-100 bg-emerald-50 px-2.5 py-0.5 text-xs font-medium text-emerald-700">
                <i className="bx bx-shield-alt-2 text-sm" />
                {current_patient.insurer.name}
              </span>
            )}
          </div>
        </header>

        {/* Tabs — la liste est rendue dans la carte ; chaque panel a son
            propre padding interne. Plus de border-md décoratif, pour
            laisser respirer le contenu. */}
        <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
          <TabsCustom errors={errors} />
        </div>
      </div>
    </DashboardWrapper>
  );
};

const mapStateToProps = ({
  usersReducer,
  consultationsReducer,
}) => ({
  current_patient: usersReducer.current_patient,
  errors: consultationsReducer.errors,
});

export default connect(mapStateToProps)(Consultation);
